import { useState } from "react";
import { mergeDeep } from "@apollo/client/utilities";

import { useMe, useFilterStorage } from "components/use-hooks";

const useCollectGraphicsFilterHook = ({
    filter: filterParams = {}
} = {}) => {
    const { me } = useMe(),
        filterStorage = useFilterStorage();

    const defaultFilter = {
        where: {
            eeId: {
                column: "EE_ID",
                operator: "EQ",
                value: me.eeCurrentId
            },
            block: {}
        },
        whereCrafts: {
            craftType: {
                column: "TYPE",
                operator: "EQ",
                value: "collect_graphics"
            },
            craftStatus: {}
        },
        activeFilters: 0
    };

    const [filter, setFilter] = useState(mergeDeep(defaultFilter, filterParams));

    filterStorage.store("collect_graphics", {
        filter
    });

    return {
        filter: {
            data: filter,
            set: setFilter,
            reset: () => setFilter(defaultFilter)
        }
    };
};

export default useCollectGraphicsFilterHook;
